<template> 
    <div v-if="isLoaded">
        <img v-if="isMarketingTemplate" :src="configTni.marketingtemplate_renewal_register_error_image_url" alt="" />
        <img v-else-if="isStandardWait" :src="configTni.consent_standard_register_error_image_url" alt="" >
        <img v-else :src="configTni.new_register_error_image_url" alt="" /> 
    </div> 
</template>
<script>  
   
//service
import ConsentApi from '../../ConsentRegister/service/ConsentApi';

export default {
    name: "StarndardRegisterSuccessPage", 
    components: {  
    },
    data: function() {
        return {   
            configTni: {},
            isMarketingTemplate: false,
            isStandardWait: false,
            isLoaded: false,
        }
    },
    created: async function() { 
        await this.getBlobConfig();
        if (this.$route.query.MarketingTemplate) {
            this.isMarketingTemplate = true
        } else if (this.$route.query.StandardWait) {
            this.isStandardWait = true
        }
    },
    methods: { 
        getBlobConfig: function() {
            return new Promise((resolve) => {
                ConsentApi.apiGetTniConfig().subscribe({
                    next: (data) => {
                        this.configTni = data;
                        this.isLoaded = true;
                        resolve(true)
                    },
                    error: (err) => {
                        this.errorApi(err);
                    },
                });
            })
        }, 
    },
}
</script>
